'use client'

import React from 'react'

import { useUploadWorkspacePicture } from '../../hooks/use-upload-workspace-picture'
import { BasePictureEditor } from '../shared/base-picture-editor'

interface IWorkspaceProfilePictureEditorProps {
  buttonText?: string
  defaultAvatarUrl?: string
  onSuccess?: () => void
  showRemoveButton?: boolean
  subtitle?: string
  title?: string
  workspaceID: string
  workspaceName?: string
}

export const WorkspaceProfilePictureEditor = ({
  defaultAvatarUrl,
  workspaceID,
  workspaceName = '',
  onSuccess,
  buttonText = 'Save',
  title = 'Set Workspace Logo',
  subtitle = 'Upload a logo for your workspace',
  showRemoveButton = false
}: IWorkspaceProfilePictureEditorProps) => {
  const { uploadAvatarAsWorkspaceLogo, uploadWorkspaceLogo, isLoading, isRemovingLogo, removeWorkspaceLogo } =
    useUploadWorkspacePicture(workspaceID)

  const handleFileUpload = async (file: Blob) => {
    await uploadWorkspaceLogo({
      fileObject: file,
      setError: () => {}
    })
  }

  const handleAvatarUpload = async (avatarUrl: string) => {
    await uploadAvatarAsWorkspaceLogo(avatarUrl)
  }

  const handleRemoveLogo = async () => {
    await removeWorkspaceLogo()
    return
  }

  return (
    <BasePictureEditor
      avatarVariant="square"
      buttonText={buttonText}
      defaultAvatarUrl={defaultAvatarUrl}
      defaultAvatarPath="default-workspace-logos"
      entityName="workspace"
      entityDisplayName={workspaceName}
      isLoading={isLoading}
      showAvatarSelection={false}
      isRemovingPicture={isRemovingLogo}
      onAvatarUploadAction={handleAvatarUpload}
      onFileUploadAction={handleFileUpload}
      onRemovePicture={handleRemoveLogo}
      onSuccess={onSuccess}
      showRemoveButton={showRemoveButton}
      subtitle={subtitle}
      title={title}
      uploadButtonText="Upload Logo"
      removeButtonText="Remove Logo"
    />
  )
}
